import { render, staticRenderFns } from "./HelmetPermissions.vue?vue&type=template&id=0877b70d&scoped=true"
import script from "./HelmetPermissions.vue?vue&type=script&lang=js"
export * from "./HelmetPermissions.vue?vue&type=script&lang=js"
import style0 from "./HelmetPermissions.vue?vue&type=style&index=0&id=0877b70d&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0877b70d",
  null
  
)

export default component.exports